<template>
    <div class="inner-box">
        <!-- <div class="content-name">
            <h2 class="dp-ib">{{ routeName }}</h2>
        </div> -->
        <div class="search-area2">
            <div>
                <search-form ref="refSearchForm" :search="search" @searchChange="searchChange" />
            </div>
        </div>
        <!-- <button @click="next">{{$refs.step}}다음</button>
        <Step ref="steps" :active="nextIdx" :steps="steps"></Step> -->
        <tabs :tab="tab" :active-btn="active" @changeTab="changeTab"/>
        <component ref="cmpTab" v-bind:is="viewer" :custParam="custParam"/>

        <!--공통-->
        <input id="hddTemp"                 type="hidden" v-model="com.hddTemp" /><!--외부 정보를 전달하기 위한 임시 공간-->
        <input id="hddCustSelectable"       type="hidden" v-model="com.hddCustSelectable" />
        <input id="hddFocusControlId"       type="hidden" v-model="com.hddFocusControlId" />
        <input id="hddSelectedTabClientID"  type="hidden" v-model="com.hddSelectedTabClientID" />
        <input id="hddFocusControlClientId" type="hidden" v-model="com.hddFocusControlClientId" />
        <input id="hddCustFindControlId"    type="hidden" v-model="com.hddCustFindControlId" />
        <input id="hddBOUND_ID"             type="hidden" v-model="com.hddBoundId" />
        <input id="hddEditable"             type="hidden" v-model="com.hddEditable" />
        <input id="hddCALL_BOUND_ID"        type="hidden" v-model="com.hddCallBoundId" /><!--콜이입시의 바운드아이디(내부)-->
        
        <!--일반상담-->
        <input id="hddCALL_ID"             type="hidden" v-model="com.hddCallId" />
        <input id="hddCAT_ID_LEVEL"        type="hidden" v-model="com.hddCallIdLevel" />
        <input id="hddCallTab_MODEL_ID"    type="hidden" v-model="com.hddCallTabModelId" />
        <input id="hddCallTab_MAKER"       type="hidden" v-model="com.hddCallTabMaker" />
        <input id="hddCallTab_MODEL_GROUP" type="hidden" v-model="com.hddCallTabModelGroup" />
        <input id="hddCallTab_MODEL_CD"    type="hidden" v-model="com.hddCallTabModelCd" />
        <input id="hddCallTab_DEPT_ID"     type="hidden" v-model="com.hddCallTabDeptCd" />
        <input id="hddCallTab_CHARGE_ID"   type="hidden" v-model="com.hddCallTabChargeId" />
        <input id="hddCallTab_CALL_TYPE"   type="hidden" v-model="com.hddCallTabCallType" />

        <!--주문상담-->
        <input id="hddORDER_ID"            type="hidden" v-model="com.hddOrderId" />
        <input id="hddOrderTab_PAY_YN"     type="hidden" v-model="com.hddOrderTabPayYn" />
    </div>
</template>

<script>

/* TEST */
import Step from '@/components/elementUI/Step/index.vue';
//import Views from '@/components/AS/Step/index.vue';

/* 검색 폼 컴포넌트 */
import SearchForm from '@/components/AS/SearchForm/index.vue';
/* Tab 구분 컴포넌트 */
import tabs from '@/components/AS/Tabs/index.vue';
import recipt from '@/components/AS/Receipt/index.vue';
import history from '@/components/AS/History/index.vue';
import normalConst from '@/components/AS/NormalConsult/index.vue';
import orderConst from '@/components/AS/OrderConsult/index.vue';

export default {
    name: 'AS접수',
    components: {Step, SearchForm, tabs, recipt, history, normalConst, orderConst},
    data() {
        return {
            drawer: false,
            direction: 'ttb',
            data: [],
            viewer: 'recipt',/** 활성화된 Tab */
            orgTab:[
                {tabId: 'recipt', tabName:'AS접수', tabCss:"btn btn-primary", tabNo:'0', tabShow: true},
                {tabId: 'history', tabName:'AS접수이력', tabCss:"btn btn-outline-primary", tabNo:'1', tabShow: true},/** 'btn btn-nonActive'버튼 비활성화 class */
                {tabId: 'normalConst', tabName:'일반상담', tabCss:"btn btn-outline-primary", tabNo:'2', tabShow: true},
                {tabId: 'orderConst', tabName:'주문상담', tabCss:"btn btn-outline-primary", tabNo:'3', tabShow: true},
            ],
            tab:[],
            search: {
                custNm: "",
                addr1: "",
                addr2: "",
                zipCd1: "",
                telNo: "",
                hpNo: "",
                boundTelNo: "",
                custId: "",
                custType: "",
                custGb: "1",
                codeNm: "",
                useType: "Y",
                inType: "", /** 유입경로 */
                inTypeVal: "" /** 유입경로 값*/
            },
            applySearchCondRecipt: false, /** 조회조건 적용여부 */
            applySearchCondNormal: false, /** 조회조건 적용여부 */
            applySearchCondOrder: false, /** 조회조건 적용여부 */
            com : {
                hddTemp: '',
                hddCustSelectable: '',   
                hddFocusControlId: '',   
                hddSelectedTabClientID: '',  
                hddFocusControlClientId: '',
                hddCustFindControlId: '',
                hddBoundId: '',         
                hddEditable: '',         
                hddCallBoundId: '0', /** 콜이입시의 바운드아이디(내부) */

                hddCallId: '',
                hddCallIdLevel: '',
                hddCallTabModelId: '',
                hddCallTabMaker: '',
                hddCallTabModelGroup: '',
                hddCallTabModelCd: '',
                hddCallTabDeptCd: '',
                hddCallTabChargeId: '',
                hddCallTabCallType: '',

                hddOrderId: '',
                hddOrderTabPayYn: ''
            },
            active: true,
            nextIdx: 1,
            steps: [{
                title: 'Step 1'
                ,description: ''
            },
            {
                title: 'Step 2'
                ,description: ''
            },
            {
                title: 'Step 3'
                ,description: ''
            }],
            grants: {},
            custParam:{},
            inType: '', /** 유입경로 */
            inTypeVal: '', /** 유입경로 값 */
            asSessionKey: Date.now() /** 세션키 */
        }
    },
    computed: {
        routeName() {
            return this.$route.name
        },
        getGrants() {
            const {grantDelete, grantInsert, grantPrint, grantSelect, grantUpdate} = this.$menu.getGrants();
            return {grantDelete, grantInsert, grantPrint, grantSelect, grantUpdate}
        }
    },
    created() {
        this.tab = _.cloneDeep(this.orgTab);

        this.$store.commit("setHeaderTitle", {
            headerComponentName: this.head,
            routeName: this.routeName,
            isMobile: this.$device.isMobile()
        });
    },
    beforeRouteLeave(to, from, next) {
        this.removeAllBizSession();
        
        next(); 
    },
    mounted() {

        if(this.$route.path === '/callMain2'){
            const params = {
                ...this.$route.params
            };

            this.reloadAsRegPage(params, 'callMain');
        }

        if(_.isEmpty(this.$route.query)){
            if(!_.isEmpty(sessionStorage.getItem(this.asSessionKey + "asReceipt"))){
                // 좌측메뉴를 통해 들어온 경우 세션 초기화
                this.initViewPage();
            }
        }


        this.grants = this.$menu.getGrants();

        const rqInboundTelNo = this.$route.query.InboundTelNo ? this.$route.query.InboundTelNo : '' // 전화가 인입됨
        const rqUserId = this.$route.query.UserId ? this.$route.query.UserId : '' // USER_ID
        const rqCALL_ID = this.$route.query.CALL_ID ? this.$route.query.CALL_ID : ''    // CALL_ID
        const rqAS_ID = this.$route.query.AS_ID ? this.$route.query.AS_ID : ''    // AS_ID
        const rqORDER_ID = this.$route.query.ORDER_ID ? this.$route.query.ORDER_ID : ''    // ORDER_ID
        const rqReservationId = this.$route.query.ReservationId ? this.$route.query.ReservationId : ''    // ReservationId
        const rqRequestId = this.$route.query.RequestId ? this.$route.query.RequestId : ''    // RequestId
        const rqCallbackId = this.$route.query.CallbackId ? this.$route.query.CallbackId : ''    // CallbackId

        this.inType = '' // 유입경로
        this.inTypeVal = ''
        if(rqInboundTelNo != ''){
            
            this.inType = 'IN_BOUND'
            this.inTypeVal = rqInboundTelNo
            this.removeAllBizSession();
            
        } else if(rqUserId != ''){
            // 기존 고객아이디로 재통화 - 팝업으로 메인창 오픈 : location.href = "../Call/CallMain.aspx?UserId=" + userId;
            this.inType = 'IN_USER_ID'
            this.inTypeVal = rqUserId
        
        } else if(rqCALL_ID != ''){
            // 기존 일반상담이력 수정(조회)
            this.inType = 'IN_CALL_ID'
            this.inTypeVal = rqCALL_ID

        } else if(rqAS_ID != ''){
            // 기존 AS상담이력 수정(조회)
            this.inType = 'IN_AS_ID'
            this.inTypeVal = rqAS_ID
            
        } else if(rqORDER_ID != ''){
            // 기존 주문상담이력 수정(조회)
            this.inType = 'IN_ORDER_ID'
            this.inTypeVal = rqORDER_ID
        
        } else if(rqReservationId != ''){
            // 예약상담
            this.inType = 'IN_RESERVATION_ID'
            this.inTypeVal = rqReservationId
        
        } else if(rqRequestId != ''){
            // 기존 BsMa이력 수정(조회) OR 기존 설치이력 수정(조회)
            this.inType = 'IN_REQUEST_ID'
            this.inTypeVal = rqRequestId
        
        } else if(rqCallbackId != ''){
            this.inType = 'IN_CALLBACK_ID'
            this.inTypeVal = rqCallbackId
        }

        this.search.inType = this.inType
        this.search.inTypeVal = this.inTypeVal

        this.search = {
            ...this.com,
            ...this.search
        }

        if(this.search.inType != ''){
            if(this.inType === 'IN_CALL_ID'){
                this.viewer = 'normalConst';
                
                this.tab[0].tabCss = 'btn btn-outline-primary';
                this.tab[1].tabCss = 'btn btn-outline-primary';
                this.tab[2].tabCss = 'btn btn-primary';
                this.tab[3].tabCss = 'btn btn-outline-primary';

                this.tab[0].tabShow = false; // AS접수
            } else {
                this.viewer = 'recipt';

                this.tab[0].tabCss = 'btn btn-primary';
                this.tab[1].tabCss = 'btn btn-outline-primary';
                this.tab[2].tabCss = 'btn btn-outline-primary';
                this.tab[3].tabCss = 'btn btn-outline-primary';

                this.tab[0].tabShow = true; // AS접수
            }

            
            console.log('this.$refs.refSearchForm: ', this.viewer, this.$refs.refSearchForm)
            //주의: mount 시점 차이로 인해서 refs로는 값이 셋팅할 수 없어서 pObj로 값을 셋팅함.
            const pObj = {
                inType: this.inType,
                inTypeVal: this.inTypeVal
            }
            this.$refs.refSearchForm.goOpen('', pObj)
        }
    },
    methods: {
        save() {
            
        },
        changeTab(params) {
            //탭변경처리 함수

            /*************************************************************************************/
            //단계1 : 탭변경이 발생전의 현재탭의 변경된값을 세션에 DELETE / INSERT 처리
            /*************************************************************************************/
            if(this.viewer === 'recipt') {
                sessionStorage.removeItem(this.asSessionKey + "asReceipt");      // AS접수제품 초기화
                sessionStorage.removeItem(this.asSessionKey + "asModelBreak");   // 고장증상 초기화

                let vAsReceipt = {
                    modelData : _.cloneDeep(this.$refs.cmpTab.data),
                    formData : _.cloneDeep(this.$refs.cmpTab.form),
                    loginId : this.$store.state.loginInfo.loginId
                } 
                    
                if(this.inType != 'IN_AS_ID' && this.$refs.refSearchForm.lastBut=='S'){
                    // 마지막 조회버튼이 상단 조회버튼(S) or AS접수탭의 처리기사버튼(R) 여부
                    vAsReceipt.formData.asAgentNm = this.$refs.refSearchForm.tmpAsAgentNm || '';
                    vAsReceipt.formData.asAgentId = this.$refs.refSearchForm.tmpAsAgentId || '';
                    vAsReceipt.formData.areaAgent = this.$refs.refSearchForm.tmpAreaAgent || '';
                    vAsReceipt.formData.userId = this.$refs.refSearchForm.tmpUserId || '';
                    vAsReceipt.formData.userNm = this.$refs.refSearchForm.tmpUserNm || '';
                }
                
                sessionStorage.setItem(this.asSessionKey + "asReceipt", JSON.stringify(vAsReceipt));

                console.log("test>>>>>>>>>>", sessionStorage.getItem(this.asSessionKey + "asReceipt"));
                const vAsModelBreak = {
                    modelBreak : _.cloneDeep(this.$refs.cmpTab.subData),
                    loginId : this.$store.state.loginInfo.loginId
                } 
                sessionStorage.setItem(this.asSessionKey + "asModelBreak", JSON.stringify(vAsModelBreak));
                
            } else if(this.viewer === 'normalConst') {
                sessionStorage.removeItem(this.asSessionKey + "normalConst");
console.log('this.$refs.cmpTab.form dddss : ', _.cloneDeep(this.$refs.cmpTab.form));
                const vNormalConst = {
                    formData : _.cloneDeep(this.$refs.cmpTab.form),
                    //callClassOpt: _.cloneDeep(this.$refs.cmpTab.callClassOpt), /** 상담유형리스트 */
                    callClassIdOpt: _.cloneDeep(this.$refs.cmpTab.callClassIdOpt), /** 상담유형리스트 Id */
                    callCatIdOpt1: _.cloneDeep(this.$refs.cmpTab.callCatIdOpt1), /** 상담분류(대) */
                    callCatIdIdOpt1: _.cloneDeep(this.$refs.cmpTab.callCatIdIdOpt1), /** 상담분류(대) Id */
                    callCatIdOpt2: _.cloneDeep(this.$refs.cmpTab.callCatIdOpt2), /** 상담분류(중) */
                    callCatIdIdOpt2: _.cloneDeep(this.$refs.cmpTab.callCatIdIdOpt2), /** 상담분류(중) Id */
                    callCatIdOpt3: _.cloneDeep(this.$refs.cmpTab.callCatIdOpt3), /** 상담분류(소) */
                    callCatIdIdOpt3: _.cloneDeep(this.$refs.cmpTab.callCatIdIdOpt3), /** 상담분류(소) Id */
                    callCatIdOpt4: _.cloneDeep(this.$refs.cmpTab.callCatIdOpt4), /** 상담분류(소) */
                    callCatIdIdOpt4: _.cloneDeep(this.$refs.cmpTab.callCatIdIdOpt4), /** 상담분류(소) Id */
                    
                    loginId : this.$store.state.loginInfo.loginId
                }
                sessionStorage.setItem(this.asSessionKey + "normalConst", JSON.stringify(vNormalConst));
            } else if(this.viewer == 'orderConst') {
                sessionStorage.removeItem(this.asSessionKey + "orderConst")      // 초기화
                const vsession = {
                    data : _.cloneDeep(this.$refs.cmpTab.data),
                    form : _.cloneDeep(this.$refs.cmpTab.form),
                    loginId : this.$store.state.loginInfo.loginId
                }

                sessionStorage.setItem(this.asSessionKey + "orderConst", JSON.stringify(vsession));
            } 

            /*************************************************************************************/
            //단계2 : 탭변경이 발생할 새로운 탭에 변경된 조회조건(applySearch~)의 값을 props속성변수(custParam)에 셋팅
            /*************************************************************************************/
            // 새로운 Tab으로 변경후 조회조건이 적용된 적이 없으면 조회함수 호출
            // 각 Tab내에 동일한 함수(applySearchCond)가 있음
            if(params.tabId === 'recipt') {
                if(!this.applySearchCondRecipt){
                    this.applySearchCondRecipt = true;

                    if(this.inType != 'IN_AS_ID'){
                        // AS접수탭 mount시에 applySearchCond 으로 셋팅하게 됨.
                        // 단, AS접수리스트 링크를 통해서 온 경우는 수정못하게 막음.

                        this.custParam = {
                            ...this.custParam,
                            applySearchCond : {
                                areaAgent: this.$refs.refSearchForm.tmpAreaAgent || '', 
                                asAgentNm: this.$refs.refSearchForm.tmpAsAgentNm || '', 
                                asAgentId: this.$refs.refSearchForm.tmpAsAgentId || '', 
                                userId: this.$refs.refSearchForm.tmpUserId || '', 
                                userNm: this.$refs.refSearchForm.tmpUserNm || '',
                                custNm: this.$refs.refSearchForm.form.custNm || '', 
                                boundTelNo: this.$refs.refSearchForm.form.boundTelNo || '', 
                                hpNo: this.$refs.refSearchForm.form.hpNo || '',
                                telNo: this.$refs.refSearchForm.form.telNo || '',
                                zipCd1: this.$refs.refSearchForm.form.zipCd1 || '',
                                addr1: this.$refs.refSearchForm.form.addr1 || '',
                                addr2: this.$refs.refSearchForm.form.addr2 || ''
                            }
                        } || {};
                    }
                    console.log('view this.custParam 1: ', _.cloneDeep(this.custParam));
                }
                
            } else if(params.tabId === 'normalConst') {
                if(!this.applySearchCondNormal){
                    this.applySearchCondNormal = true;
                    
                    if(this.inType != 'IN_AS_ID'){
                        // 일반상담탭 mount시에 applySearchCond 으로 셋팅하게 됨.
                        // 단, AS접수리스트 링크를 통해서 온 경우는 수정못하게 막음.
                        this.custParam = {
                            ...this.custParam,
                            applySearchCond : {
                                custNm: this.$refs.refSearchForm.form.custNm || '', 
                                hpNo: this.$refs.refSearchForm.form.hpNo || '',
                                telNo: this.$refs.refSearchForm.form.telNo || ''
                            }
                        } || {};
                    }
                }
            } else if(params.tabId == 'orderConst') {
                if(!this.applySearchCondOrder){
                    this.applySearchCondOrder = true;
                    
                    if(this.inType != 'IN_AS_ID'){
                        // 주문상담탭 mount시에 applySearchCond 으로 셋팅하게 됨.
                        // 단, AS접수리스트 링크를 통해서 온 경우는 수정못하게 막음.
                        this.custParam = {
                            ...this.custParam,
                            applySearchCond : {
                                custNm: this.$refs.refSearchForm.form.custNm || '', 
                                boundTelNo: this.$refs.refSearchForm.form.boundTelNo || '', 
                                hpNo: this.$refs.refSearchForm.form.hpNo || '',
                                telNo: this.$refs.refSearchForm.form.telNo || '',
                                zipCd1: this.$refs.refSearchForm.form.zipCd1 || '',
                                addr1: this.$refs.refSearchForm.form.addr1 || '',
                                addr2: this.$refs.refSearchForm.form.addr2 || ''
                            }
                        } || {};
                    } 
                }
            }

            this.viewer = params.tabId; // 클릭한 새로운 Tab으로 셋팅
            
        },
        clearReceiptTab(){
            // AS접수tab 초기화
            if(this.viewer === 'recipt') {
                // console.log('========clear :::', this.$refs.cmpTab)
                this.$refs.cmpTab.data = [];
                this.$refs.cmpTab.subData = [];
                this.$refs.cmpTab.custType = 'Default';
                this.$refs.cmpTab.propensity = 'Default';
                this.$refs.cmpTab.propensityBigo = ''; 
                this.$refs.cmpTab.positionNm = ''; 
                this.$refs.cmpTab.hpNo = ''; 
                this.$refs.cmpTab.officeTelNo = ''; 
                this.$refs.cmpTab.etcTelNo1 = ''; 
                this.$refs.cmpTab.etcTelNo2 = ''; 
                this.$refs.cmpTab.boundTelNo = '';
                this.$refs.cmpTab.smsYn = '';
                this.$refs.cmpTab.telYn = '';
                this.$refs.cmpTab.addr1 = '';
                this.$refs.cmpTab.addr2 = '';
                this.$refs.cmpTab.zipCd = '';
                this.$refs.cmpTab.zipCd1 = '';
                this.$refs.cmpTab.juminNo = '';
                this.$refs.cmpTab.form.callMemo = '';  /** 고객요구사항 */
                this.$refs.cmpTab.form.visitMemo = '';  /** 특이사항 */
                this.$refs.cmpTab.form.areaAgent = '';  /** 지역ID */
                this.$refs.cmpTab.form.asAgentId = '';  /** 처리센터 ID */
                this.$refs.cmpTab.form.asAgentNm = '';  /** 처리센터 */
                this.$refs.cmpTab.form.userNm = '';  /**처리기사 */
                this.$refs.cmpTab.form.userId = '';  /**처리기사 */
                this.$refs.cmpTab.form.allocationDt = '';  /** 배정일시 */
                this.$refs.cmpTab.form.tripGrade = '무급지';  /** 출장급지 */
                this.$refs.cmpTab.form.custNm = '';  /** 신고자명 */
                this.$refs.cmpTab.form.telNo = '';  /** 신고자 전화번호 */
                this.$refs.cmpTab.form.requestVisitDt = '';  //this.$moment().format('YYYY-MM-DD'), /** 요청일시 : 처리기사 팝업에서 지정한 날짜 */
                this.$refs.cmpTab.form.requestVistHh = ''; /** 요청일시 시간 */
                this.$refs.cmpTab.form.requestVistMm = ''; /** 요청일시 분 */
                
                this.$refs.refSearchForm.lastBut = 'S';

            } else if(this.viewer === 'normalConst') {
                this.$refs.cmpTab.form.custNm = '';
                this.$refs.cmpTab.form.custType = 'Default';
                this.$refs.cmpTab.form.propensity = 'Default';
                this.$refs.cmpTab.form.propensityBigo = ''; 
                this.$refs.cmpTab.form.positionNm = ''; 
                this.$refs.cmpTab.form.hpNo = ''; 
                this.$refs.cmpTab.form.officeTelNo = ''; 
                this.$refs.cmpTab.form.etcTelNo1 = ''; 
                this.$refs.cmpTab.form.etcTelNo2 = ''; 
                this.$refs.cmpTab.form.boundTelNo = ''; 
                this.$refs.cmpTab.form.smsYn = 'Y';
                this.$refs.cmpTab.form.telYn = '';
                this.$refs.cmpTab.form.addr1 = '';
                this.$refs.cmpTab.form.addr2 = '';
                this.$refs.cmpTab.form.zipCd = '';
                this.$refs.cmpTab.form.zipCd1 = '';
                this.$refs.cmpTab.form.juminNo = '';
                this.$refs.cmpTab.form.chargeId = '0';
                this.$refs.cmpTab.form.deptId = '0';
                this.$refs.cmpTab.form.inType = '0';
                
                this.$refs.cmpTab.form.callClass = ''; /** 상담유형 */
                this.$refs.cmpTab.form.callCatId1 = ''; /** 상담분류(대) */
                this.$refs.cmpTab.form.callCatId2 = ''; /** 상담분류(중) */
                this.$refs.cmpTab.form.callCatId3 = ''; /** 상담분류(소) */
                this.$refs.cmpTab.form.callCatId4 = ''; /** 상담분류(소2) */
                this.$refs.cmpTab.form.maker = ''; /** 제조사 */
                this.$refs.cmpTab.form.makerNm = ''; /** 제조사명 */
                this.$refs.cmpTab.form.modelGroupNm = ''; /** 모델그룹명 */
                this.$refs.cmpTab.form.modelGroup = ''; /** 모델그룹 */
                this.$refs.cmpTab.form.standardModelNm = ''; /** 표준모델 */
                this.$refs.cmpTab.form.modelNm = ''; /** 모델명 */
                this.$refs.cmpTab.form.modelId = ''; /** 모델ID */
                
                this.$refs.cmpTab.form.question = ''; /** 문의내역 */
                this.$refs.cmpTab.form.answer = ''; /** 답변내역 */
                this.$refs.cmpTab.form.memo = ''; /** 기타메모 */
                this.$refs.cmpTab.form.consultCustNm = ''; /** 고객명 */
                this.$refs.cmpTab.form.consultTelNo = ''; /** 연락처 */
                this.$refs.cmpTab.form.callType = ''; /** 처리결과 */
                this.$refs.cmpTab.form.chargeNm = ''; /** 상담원 */
                this.$refs.cmpTab.form.catId = ''; /** 최종 저장될 cat id */
                this.$refs.cmpTab.form.custId = '';

            } else if(this.viewer === 'orderConst') {
                this.$refs.cmpTab.form.custNm = '';
                this.$refs.cmpTab.form.custType = 'Default';
                this.$refs.cmpTab.form.propensity  = 'Default';
                this.$refs.cmpTab.form.propensityBigo = ''; 
                this.$refs.cmpTab.form.positionNm = ''; 
                this.$refs.cmpTab.form.hpNo = ''; 
                this.$refs.cmpTab.form.officeTelNo = ''; 
                this.$refs.cmpTab.form.etcTelNo1 = ''; 
                this.$refs.cmpTab.form.etcTelNo2 = ''; 
                this.$refs.cmpTab.form.boundTelNo = ''; 
                this.$refs.cmpTab.form.smsYn = 'Y';
                this.$refs.cmpTab.form.telYn = '';
                this.$refs.cmpTab.form.addr1 = ''; /** 주소1 */
                this.$refs.cmpTab.form.addr2 = ''; /** 주소2 */
                this.$refs.cmpTab.form.zipCd = '';
                this.$refs.cmpTab.form.zipCd1 = '';
                this.$refs.cmpTab.form.juminNo = '';
                this.$refs.cmpTab.form.inType = '0';
                
                this.$refs.cmpTab.form.orderId = ''; /** 주문번호 */     
                this.$refs.cmpTab.form.orderTelNo = '';        
                this.$refs.cmpTab.form.orderDt = this.$moment().format('YYYY-MM-DD HH:mm:ss'); /** 주문일시 */
                this.$refs.cmpTab.form.orderAmt = '0'; /** 청구금액 */
                this.$refs.cmpTab.form.orderCustNm = ''; /** 주문자명 */
                this.$refs.cmpTab.form.payBank = ''; /** 입금은행 */
                this.$refs.cmpTab.form.payAccount = ''; /** 계좌번호 */
                this.$refs.cmpTab.form.telNo = ''; /** 연락처 */
                this.$refs.cmpTab.form.deliveryNm = ''; /** 받을사람 */
                this.$refs.cmpTab.form.deliveryTelNo = ''; /** 전화번호 */
                this.$refs.cmpTab.form.deliveryHpNo = ''; /** 핸드폰 */
                this.$refs.cmpTab.form.memo = ''; /** 주문메모 */
                this.$refs.cmpTab.form.billYn = ''; /** 계산서 발생유무 */
            }
            
        },
        directTabChange(){
            /** 현재 활성화된 Tab에 그대로 수정할 경우 */

            if(this.viewer === 'recipt') {
                let vObj = this.$refs.refSearchForm.form;
                this.$refs.cmpTab.form.custNm = vObj.custNm || '';

                let vTelNo = vObj.telNo || '';
                if(vTelNo === ''){
                    vTelNo = vObj.hpNo || '';
                }

                if(vTelNo === ''){
                    vTelNo = vObj.boundTelNo || '';
                }
 
                this.$refs.cmpTab.form.telNo = vTelNo;
                this.applySearchCondRecipt = true; /** 조회조건 적용여부 */
            }
            
        },
        searchContentInTab(param){
            /**
             * 현재 뷰내의 자식콤포넌트인 SearchForm에서 DB데이타를 조회하여
             *  활성화된 자식콤포넌트(recipt, history, normalConst, orderConst)의 data에 값을 셋팅처리
             */

            // AS접수이력 조회
            console.log('AS접수이력 Call : searchContentInTab param:' , param);
            // history.data = param || []
            // history.methods.proc()
            
            // this.histList = param.callAsCustSelPageList || []
            // this.custInfo = param.callCustSelItemList || {}
            console.log(' cmpTab ref: ', this.$refs.cmpTab);
            
            this.applySearchCondRecipt = false; /** 조회조건 적용여부 */
            this.applySearchCondNormal = false; /** 조회조건 적용여부 */
            this.applySearchCondOrder = false; /** 조회조건 적용여부 */
            this.removeAllBizSession();

            this.custParam = {
                ...param,
                ...this.com,
                inType : this.inType,
                inTypeVal: this.inTypeVal
             } || {}

            if(this.viewer === 'recipt') {
                const vReciptObj = {
                    popHeadInfo: param.popHeadInfo || {},
                    callAsDetail: param.callAsDetail || [],
                    callAsCat: param.callAsCat || [],
                    callAsMstSelList: param.callAsMstSelList || [],
                    callCustSelItemList: param.callCustSelItemList || [],
                    tripGrade: param.tripGrade || [],
                    callServiceEngineerFind: param.callServiceEngineerFind || [],
                    inType : this.inType,
                    inTypeVal: this.inTypeVal
                }

                this.$refs.cmpTab.setReciptList(vReciptObj)
            } else if(this.viewer === 'history') {
                const vHistObj = {
                    getAsStatus : param.getAsStatus || [],
                    callAsCustSelPageList : param.callAsCustSelPageList || [],
                    inType : this.inType,
                    inTypeVal: this.inTypeVal
                }
                this.$refs.cmpTab.setHistoryList(vHistObj)
            } else if(this.viewer === 'normalConst') {
                const vNormalObj = {
                    popHeadInfo: param.popHeadInfo || {},
                    getCatDataByParent: param.getCatDataByParent || [],
                    callParamCustSelPageList: param.callParamCustSelPageList || [],
                    callCustPageist: param.callCustPageist || [],
                    inType : this.inType,
                    inTypeVal: this.inTypeVal
                }
                
                this.$refs.cmpTab.setNormalList(vNormalObj)
            } else if(this.viewer == 'orderConst') {
                const vOrderObj = {
                    callCustSelItemList: param.callCustSelItemList || [],
                    inType : this.inType,
                    inTypeVal: this.inTypeVal,
                    ...param.popHeadInfo
                }
                
                this.$refs.cmpTab.setOrderList(vOrderObj)
            }

            
        },
        handleClose(done) {
            this.$confirm('Are you sure you want to close this?')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },
        next() {
            console.log('AsMng next() start')
            if (this.nextIdx++ > this.steps.length-1) {
                this.nextIdx = 1;
            }
            //console.log(this.$refs.steps.$refs)
            if(this.nextIdx === 1) {
                console.log(`step1`,this.$refs.steps.$refs.step3)
            } else if(this.nextIdx === 2) {
                console.log(`step2`, this.$refs.steps.$refs.step1)
            } else if(this.nextIdx === 3) {
                console.log(`step3`, this.$refs.steps.$refs.step2)
            }
            return this.nextIdx;
        },
        removeAllBizSession() {
            // 각 Tab내의 세션정보 초기화

            sessionStorage.removeItem(this.asSessionKey + "asReceipt");      // AS접수제품 초기화
            sessionStorage.removeItem(this.asSessionKey + "asModelBreak");   // 고장증상 초기화

            sessionStorage.removeItem(this.asSessionKey + "normalConst");    // 일반상담 초기화
            sessionStorage.removeItem(this.asSessionKey + "orderConst");     // 주문상담 초기화
        },
        searchChange(param){
            console.log('search called: ', param);
            let vOnlySearch = _.cloneDeep(param);
            
            delete vOnlySearch.asAgentId;
            delete vOnlySearch.asAgentNm;
            delete vOnlySearch.areaAgent;
            delete vOnlySearch.userId;
            delete vOnlySearch.userNm;

            console.log('search called vOnlySearch: ', vOnlySearch);
            this.search = {
                    ...this.search,
                    ...vOnlySearch
                };

            if(this.viewer === 'recipt' && this.$refs.cmpTab.form) {
                if(this.inType != 'IN_AS_ID'){
                    // 접수리스트를 통한 접근시(IN_AS_ID)는 접수데이타로 조회하기때문에 
                    // 그외의 경우만 AS배정 정보를 변경시킴.
                    
                    this.$refs.cmpTab.form.areaAgent = param.areaAgent || '';  /** 지역ID */
                    this.$refs.cmpTab.form.asAgentId = param.asAgentId || '';  /** 처리센터 ID */
                    this.$refs.cmpTab.form.asAgentNm = param.asAgentNm || '';  /** 처리센터 */
                    this.$refs.cmpTab.form.userId = param.userId || '';  /** 처리기사 */
                    this.$refs.cmpTab.form.userNm = param.userNm || '';  /** 처리기사 */

                    this.$refs.cmpTab.form.custNm = param.custNm || '';  
                    this.$refs.cmpTab.form.custId = param.custId || '';  
                    
                    // 휴대폰우선 차선이 일반전화. 발신번호는 제외
                    let vHpNo = param.hpNo || '';
                    if(vHpNo === ''){
                        vHpNo = param.telNo || '';
                    }

                    if(param.telNo && param.telNo != ''){
                        this.$refs.cmpTab.form.telNo = param.telNo;  
                    } else {
                        this.$refs.cmpTab.form.telNo = vHpNo || '';  
                    }

                    this.$refs.cmpTab.form.addr1 = param.addr1 || '';
                    this.$refs.cmpTab.form.addr2 = param.addr2 || '';
                    this.$refs.cmpTab.form.zipCd = param.zipCd1 || '';
                    this.$refs.cmpTab.form.zipCd1 = param.zipCd1 || '';
                }
                
                this.$refs.cmpTab.form.smsYn = param.smsYn || 'Y';  
                
            } else if(this.viewer === 'normalConst' && this.$refs.cmpTab.form) {
                if(this.inType != 'IN_AS_ID'){
                    // 접수리스트를 통한 접근시(IN_AS_ID)는 접수데이타로 조회하기때문에 
                    // 그외의 경우만 AS배정 정보를 변경시킴.
                    
                    this.$refs.cmpTab.form.consultCustNm = param.custNm;  /** 고객명 */

                    // 휴대폰우선 차선이 일반전화. 발신번호는 제외
                    let vHpNo = param.hpNo || '';
                    if(vHpNo === ''){
                        vHpNo = param.telNo || '';
                    }
                    this.$refs.cmpTab.form.consultTelNo = vHpNo; // 연락처
                }   
            } else if(this.viewer === 'orderConst' && this.$refs.cmpTab.form) {
                this.$refs.cmpTab.form.orderCustNm = param.custNm;  /** 고객명 */
                this.$refs.cmpTab.form.deliveryNm = param.custNm;  /** 고객명 */
                 
                let vTelNo = param.telNo || '';
                let vHpNo = param.hpNo || '';

                this.$refs.cmpTab.form.deliveryTelNo = vTelNo;  /** 배송지 전화번호 */
                this.$refs.cmpTab.form.deliveryHpNo = vHpNo;  /** 배송지 휴대폰 */
                this.$refs.cmpTab.form.zipCd1 = param.zipCd1;
                this.$refs.cmpTab.form.addr1 = param.addr1;
                this.$refs.cmpTab.form.addr2 = param.addr2;

                if(vHpNo === ''){
                    this.$refs.cmpTab.form.orderTelNo = vTelNo; /** 결제방법 연락처 */
                } else {
                    this.$refs.cmpTab.form.orderTelNo = vHpNo; /** 결제방법 연락처 */
                }
                
            }
        },
        initViewPage(){
            // 하위 Component인 AS접수, 일반상담, 주문상담 Tab에서 초기화시 사용
            
            this.removeAllBizSession();
            this.$refs.refSearchForm.initCust('NO_ALERT');
        },
        reloadAsRegPage(params, vName){
            console.log('reloadAsRegPage : ', params);
            let vRouterName = 'callMain2';
            if(vName){
                vRouterName = vName;
            }

            this.$router.push({          
                name: vRouterName,
                params: {}
            });
        }
        
    }
}
</script>